// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#shu-booking-form .field-wrapper{display:block;margin-bottom:1.5em}#shu-booking-form .field-wrapper__label{display:block;font-weight:300;margin-bottom:0.5em;font-size:0.9em}#shu-booking-form .field-wrapper--has-error{color:#e43027}#shu-booking-form .field-wrapper__error{margin-top:0.5em;display:block;font-size:0.8em}#shu-booking-form .field-wrapper__warning-icon{margin-left:0.5em;fill:#e43027}\n", ""]);
// Exports
module.exports = exports;
